<template>
	<div class="purchase-order">
		<div class="fx-header goback">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<p>常购单设置</p>
		</div>
		<div style="overflow-y: hidden;display:flex;flex-direction: column;">
			<div style="flex:1;overflow-y:auto">
				<el-form :model="ruleForm" :rules="rules" :inline-message='false' ref="ruleForm" label-width="107px" class="form-box">
					<el-form-item label="常购单名称：" prop="name">
						<el-input v-model="ruleForm.name" size='mini' :maxlength='50' style="width: 200px;" placeholder="请输入常购单名称"></el-input>
					</el-form-item>
					<el-form-item label="常购单状态：" prop="status" size='mini'>
						<el-radio-group v-model="ruleForm.status">
							<el-radio label="false">启用</el-radio>
							<el-radio label="true">停用</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="适用门店：" prop=" " size='mini'>
						<el-radio v-model="shopattendway" :label="0">全部门店</el-radio>
						<el-radio v-model="shopattendway" :label="1">自定义门店</el-radio>
						<span v-if="shopattendway === 1" @click="bindShopClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
							<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
							选择门店
						</span>
					</el-form-item>
					<el-form-item v-if="shopattendway === 1" label="已选：" size='mini'>
						<span>{{shopText}}</span>
					</el-form-item>
					<el-form-item label="适用客户：" prop=" " size='mini'>
						<el-radio v-model="customerattendway" :label="0">全部客户</el-radio>
						<el-radio v-model="customerattendway" :label="1">自定义客户</el-radio>
						<span v-if="customerattendway === 1" @click="addCusClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
							<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
							选择客户
						</span>
					</el-form-item>
					<el-form-item v-if="customerattendway === 1" label="已选：" size='mini'>
						<span>{{cusText}}</span>
					</el-form-item>
				</el-form>
				<div class="search-table-box">
					<Search  @handleSearch="handleSearch"/>
					<div class="features-btn-box">
						<el-button type="primary" size='small' class="fx-big-btn" plain @click="addGoods">添加商品</el-button>
						<el-button type="primary" size='small' class="fx-big-btn" plain @click="delGoods">删除商品</el-button>
					</div>
					<MainTable
						:tableData='tableData'
						:regularpurchaseProductListId='regularpurchaseProductListId'
						@delSuc='delSuc'
						@delIds='delIds'
						ref="tableRef"
					/>
				</div>
			</div>
			<div class="store-info-btn">
				<el-button class="btn" size='small' plain type="primary" @click="goBack">取消</el-button>
				<el-button class="btn" size='small' type="primary" @click="saveInfo">保存</el-button>
			</div>
		</div>
		<el-dialog
			top='100px'
			title="添加商品"
			class="dialog-title"
			:visible.sync="visible"
			width='1200px'
			:before-close="cancel"
			:close-on-click-modal="false">
			<div>
				<AddGoods v-if="visible" :visible="visible" :regularpurchaseProductListId="regularpurchaseProductListId" @closeDialog="closeDialog" @saveEvent="saveEvent"></AddGoods>
			</div>
		</el-dialog>

		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog
			title="选择适用客户"
			:visible.sync="customerDialog"
			class="dialog-title"
			width="780px"
			top="60px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<bind-customer v-if="customerDialog" :customerDialog.sync="customerDialog" @reloadCus='reloadCus' :customertype='customertype' :chooseCusByCate='chooseCusByCate' :chooseCusBylevel='chooseCusBylevel'></bind-customer>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import BindCustomer from '@/views/index/src/marketing/src/bindCustomer.vue'
import Search from '@/components/purchaseOrder/Search.vue'
import MainTable from '@/components/purchaseOrder/MainTable.vue'
import AddGoods from '@/components/purchaseOrder/AddGoods.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'purchaseOrder',
	components: {
		Search,
		MainTable,
		AddGoods,
		bindShop,
		BindCustomer
	},
	data () {
		return {
			customertype: 0,
			customerattendway: 0,
			shopattendway: 0,
			customerDialog: false,
			shopDialog: false,
			regularpurchaseProductListId: '',
			visible: false,
			chooseShop: [],
			tableData: [],
			ruleForm: {
				name: '',
				status: 'false'
			},
			rules: {
				name: [
					{ required: true, message: '常购单名称不得为空' }
				],
				status: [
					{ required: true }
				]
			},
			goodsName: '',
			stackflag: -1,
			salestate: -1,
			bcId: '',
			scId: '',
			editCartInfos: [],
			ids: '',
			chooseCusByCate: [],
			chooseCusBylevel: [],
			chooseCus: [],
			cusText: '',
			shopText: ''
		}
	},
	created () {
		if (this.$route.query.id) {
			this.regularpurchaseProductListId = this.$route.query.id
			this.getDetail()
		}
	},
	methods: {
		checkCusNum (data) {
			let num = 0
			data.forEach(item => {
				if (item.id !== '-1') {
					num++
				}
			})
			return num
		},
		initShopData (data) {
			let textArr = []
			let ids = []
			data.forEach(item => {
				ids.push(item.shopid)
				textArr.push(item.shopname)
			})
			this.shopText = textArr.join('，')
			this.chooseShop = ids
		},
		initCusData () {
			let textArr = []
			let list = this.chooseCus
			list.forEach(item => {
				let itemText = ''
				if (item.categoryOrLevelFlag === 1) {
					itemText = item.name + '（整类）'
				} else {
					itemText = item.name + '（' + this.checkCusNum(item.cus) + '个）'
				}
				textArr.push(itemText)
			})
			this.cusText = textArr.join('，')
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			console.log(this.chooseShop)
			this.shopText = data.shopText
			this.shopDialog = false
		},
		reloadCus (data) {
			this.chooseCus = data.chooseData
			this.customertype = data.customertype
			if (this.customertype === 0) {
				this.chooseCusByCate = this.chooseCus
			} else {
				this.chooseCusBylevel = this.chooseCus
			}
			this.initCusData()
			this.customerDialog = false
		},
		addCusClick () {
			this.customerDialog = true
		},
		bindShopClick () {
			this.shopDialog = true
		},
		handleSearch (value) {
			this.goodsName = value.goodsName
			this.stackflag = value.stackflag
			this.salestate = value.salestate
			this.bcId = value.bcId
			this.scId = value.scId
			this.getDetail()
		},
		delIds (data) {
			this.ids = data.join(',')
		},
		delGoods () {
			if (this.ids === '') {
				this.$message.error('请至少选择一个商品！')
				return false
			}
			this.$confirm('是否删除商品？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					relListidArr: this.ids
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/rel/delete`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功！')
						this.getDetail()
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		delSuc () {
			this.getDetail()
		},
		saveInfo () {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					let editCartInfos = this.$refs.tableRef.getData()
					let cloneEditCartInfos = JSON.parse(JSON.stringify(editCartInfos))
					cloneEditCartInfos.forEach(item => {
						item.modifyflag = item.modifyflag ? 1 : 0
						item.mustbuyflag = item.mustbuyflag ? 1 : 0
					})
					if (editCartInfos.length < 1) {
						this.$message.error('请添加商品')
						return false
					}
					let emptyArr = editCartInfos.filter(item => {
						return item.itemQuantity === ''
					})
					if (emptyArr.length > 0) {
						this.$message.error('请填写商品数量')
						return false
					}
					if (this.shopattendway === 1 && this.chooseShop.length === 0) {
						this.$message.error('请选择适用门店')
						return false
					}
					if (this.customerattendway === 1 && this.chooseCus.length === 0) {
						this.$message.error('请选择适用客户')
						return false
					}
					let params = {
						shopattendway: this.shopattendway,
						customerattendway: this.customerattendway,
						customertype: this.customertype,
						shopInfos: this.chooseShop,
						customerInfos: this.chooseCus,
						regularpurchaseListId: this.regularpurchaseProductListId,
						name: this.ruleForm.name,
						disabledflag: this.ruleForm.status === 'true' ? 1 : 0,
						editCartInfos: cloneEditCartInfos
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/saveOrUpdate`,
						data: params
					}).then(res => {
						if (res.result) {
							this.regularpurchaseProductListId = res.data
							this.$message.success('保存成功！')
							this.$router.push('/main/purchaseOrderSetting')
						} else {
							this.$message.error(res.msg)
						}
					})
				}
			})
		},
		getDetail () {
			let params = {
				regularpurchaseListId: this.regularpurchaseProductListId,
				disabledflag: this.stackflag,
				planDisabledflag: this.salestate,
				bcId: this.bcId,
				scId: this.scId,
				productname: this.goodsName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.ruleForm.name = res.data.regularPurchaseList.name
					this.shopattendway = res.data.regularPurchaseList.shopattendway
					this.customerattendway = res.data.regularPurchaseList.customerattendway
					this.customertype = res.data.regularPurchaseList.customertype


					let cusList = res.data.customers
					cusList.forEach(item => {
						item.name = this.customertype === 0 ? item.categoryname : item.levelname
						item.id = this.customertype === 0 ? item.categoryid : item.levelid
						item.showCus = 1
					})
					cusList = JSON.parse(JSON.stringify(cusList))
					this.chooseCus = cusList
					if (this.customertype === 0) {
						this.chooseCusByCate = this.chooseCus
					} else {
						this.chooseCusBylevel = this.chooseCus
					}


					this.initCusData()
					this.initShopData(res.data.shops)

					this.ruleForm.status = res.data.regularPurchaseList.disabledflag ? 'true' : 'false'
					let tableData = res.data.products
					tableData.forEach(item => {
						item.modifyflag = item.modifyflag === 1
						item.mustbuyflag = item.mustbuyflag === 1
					})
					tableData.forEach(item => {
						item.salestate = item.salestate === 1 ? '停售' : '可售'
						item.stackflag = item.stackflag ? '停用' : '启用'
					})
					this.tableData = tableData
				}
			})
		},
		closeDialog () {
			this.visible = false
		},
		saveEvent (event) {
			this.editCartInfos = event.editCartInfos
			let params = {
				shopattendway: this.shopattendway,
				customerattendway: this.customerattendway,
				customertype: this.customertype,
				shopInfos: this.chooseShop,
				customerInfos: this.chooseCus,
				regularpurchaseListId: this.regularpurchaseProductListId,
				name: this.ruleForm.name,
				disabledflag: this.ruleForm.status === 'true' ? 1 : 0,
				editCartInfos: this.editCartInfos
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/saveOrUpdate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.regularpurchaseProductListId = res.data
					this.visible = false
					this.$message.success('添加成功！')
					this.getDetail()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancel () {
			this.visible = false
		},
		goBack () {
			this.$router.push('/main/purchaseOrderSetting')
		},
		addGoods () {
			this.visible = true
		}
	}
}
</script>

<style lang="stylus" scoped>
.purchase-order {
	display flex;
	flex-direction column;
	.goback{
		span {
			float left
			display inline-block
			line-height 55px
			padding-right 20px
			margin-top :10px
			i {
				border-radius: 50%;
				text-align: center;
				background: #9da6af;
				padding: 3px;
				cursor: pointer;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.form-box {
		display flex
		flex-direction column
		text-align left
		justify-content space-between;
		padding-top: 10px;
	}
	.search-table-box {
		min-height 0;
		flex-direction column
		.features-btn-box {
			text-align left
			padding 20px 0
			box-sizing border-box
			display: flex;
		}
	}
	.dialog-title {
		text-align: left
	}
	.store-info-btn {
		box-sizing: border-box;
		padding: 20px 0
		display: flex;
		justify-content: center;
		.btn {
			width :150px;
			height :35px;
		}
	}
}
</style>
<style lang="stylus">
.purchase-order {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}
}
</style>
